import useStore from 'state/knovStore'

const HIGHLIGHT_DURATION_MS = 1000

export default function useSearchHeaderHighlight() {
    const highlightSearchHeader = (panelId, options = {}) => {
        if (!panelId) return

        const { delay = 0 } = options

        const triggerHighlight = () => {
            useStore.getState().set(state => {
                state.searchHeaderAnimationStates = {
                    ...state.searchHeaderAnimationStates,
                    [panelId]: {
                        state: 'fadeIn',
                        timestamp: Date.now(),
                    },
                }
            })

            setTimeout(() => {
                useStore.getState().set(state => {
                    if (state.searchHeaderAnimationStates?.[panelId]) {
                        state.searchHeaderAnimationStates[panelId].state = 'fadeOut'
                    }
                })
            }, HIGHLIGHT_DURATION_MS)
        }

        if (delay > 0) {
            setTimeout(triggerHighlight, delay)
        } else {
            triggerHighlight()
        }
    }

    return highlightSearchHeader
}
